module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-responsive table-striped"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column) {
    return (column.sortable) ? _c('th', {
      key: column.name,
      class: _vm.sortKey === column.name ? (_vm.sortOrders[column.name] > 0 ? 'sorting_asc' + ' ' + column.class : 'sorting_desc' + ' ' + column.class) : 'sorting' + ' ' + column.class,
      style: ('cursor:pointer;'),
      attrs: {
        "scope": "col"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('sort', column.name)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.trans('columns.' + column.name)) + "\n        ")]) : _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.trans('columns.' + column.name)) + "\n        ")])
  }), 0)]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3feeeaf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Datatable.vue
// module id = 107
// module chunks = 0